import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import BodmasCategoryTable from './BodmasCategoryTable';

const BodmasCategory = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Bodmas Test Category' parent='Bodmas TestSeries' />
      <Container fluid={true}>
        <Row>
          <BodmasCategoryTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default BodmasCategory;
